var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',{staticClass:"ml-auto"},[_c('a',{attrs:{"href":"https://apachedigital.io","target":"_blank"}},[_vm._v("Apache Digital © 2021")])])])}
var staticRenderFns = []

export { render, staticRenderFns }